import { render } from "./ListTrashCommunityView.vue?vue&type=template&id=72dc3f9d"
import script from "./ListTrashCommunityView.vue?vue&type=script&lang=js"
export * from "./ListTrashCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__